export default "__VITE_ASSET__KlXvuq6z__"